import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "inherit",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M2.25 2.25h10.5M4 8.083l3.5-3.5m0 0 3.5 3.5m-3.5-3.5v8.167"
    }, null, -1)
  ]))]))
}
export default { render: render }